import { toast } from 'react-toastify';
import QueryParams from '../../services/QueryParams';
import FormData from '../../services/FormData';
import Http from '../../services/Http';
import Storage from '../../services/Storage';
import Logo from '../../logos/logo-white.png';
import { Link, useHistory } from 'react-router-dom';
import { useEffect, useCallback, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import IEVersion from '../../services/IEVersion';
import Copyright from '../../common/Copyright';
import PrivacyPolicy from '../../common/PrivacyPolicy';
import OtpInput from 'react-otp-input';
import ReCaptcha from '../../common/ReCaptcha';

const SignUp = (props: any) => {
    const [http] = useState(new Http());
    const [storage] = useState(new Storage());
    const [queryParams] = useState(new QueryParams());
    const [processing, setProcessing] = useState(false);
    const [token, setToken] = useState("");
    const [otp, setOtp] = useState("");
    const [action, setAction] = useState("otp");
    const history = useHistory();
    const [reCaptchaToken, setReCaptchaToken] = useState("");
    const [reCaptchaTimestamp, setReCaptchaTimestamp] = useState(0);
    const [otpMessage, setOtpMessage] = useState("");
    const [resendOtpIn, setResendOtpIn] = useState(0);

    useEffect(() => {
        setTimeout(() => {
            if (resendOtpIn) {
                setResendOtpIn(resendOtpIn - 1);
            } else {
                reCaptchaReload();
            }
        }, 1000)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resendOtpIn]);

    const handleAction = useCallback((resp: any, overriddenAction?: string) => {
        switch (overriddenAction || action) {
            case "otp":
                setAction("verify-otp");
                setOtpMessage(resp.message);
                setResendOtpIn(90);
                toast.success(resp.message);
                break;

            case "verify-otp":
                setToken(resp.token);
                setAction("password");
                toast.success(resp.message);
                break;

            case "password":
                toast.success(resp.message);
                storage.token(resp.token);
                storage.email(resp.email);
                history.push({
                    pathname: "/login",
                    search: queryParams.search()
                });
                break;
        }
    }, [action, history, queryParams, storage]);

    const submitForm = useCallback(async (e) => {
        let overriddenAction = undefined;
        if (typeof e != "string") {
            e.preventDefault();
        } else {
            overriddenAction = e;
        }
        setProcessing(true);
        try {
            const resp = await http.post(`sign-up/${overriddenAction || action}`, new FormData('sign_up_form')
                .toJson());
            if (resp.status < 400) {
                handleAction(resp.data, overriddenAction);
            } else {
                // eslint-disable-next-line no-mixed-operators
                toast.error(resp && resp.data && resp.data.message || "Something went wrong.");
            }
        } catch (e: any) {
            toast.error(e && e.response && e.response.data && e.response.data.message ? e.response.data.message : ((e && e.message) || "Something went wrong."));
        }
        reCaptchaReload();
        setProcessing(false);
    }, [action, handleAction, http]);

    const reCaptchaReload = () => {
        setReCaptchaTimestamp(new Date().getTime());
    };

    const buttonText = () => {
        switch (action) {
            case "otp":
                return "Request OTP";

            case "password":
                return "Continue";

            case "verify-otp":
            default:
                return "Submit";
        }
    }

    return (
        <div className="global-container bg-gradient">
            <ReCaptcha action="SIGN_UP" reCaptchaTimestamp={reCaptchaTimestamp} onToken={setReCaptchaToken} />
            <div id="tweak">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="text-center">
                                <img src={Logo} style={{ pointerEvents: 'none' }} width="220" alt="" />
                            </div>
                            <div className="card login-form mt-4 ml-auto mr-auto">
                                <div className="card-body">
                                    <div className="card-text">
                                        {action === 'otp' ? <div className="form-group">
                                            <h4 className='opacity-8 text-center'>Create an account</h4>
                                            <p className=' text-center opacity-7 mt-2 pt-1'>
                                                Please enter your email to continue.
                                            </p>
                                        </div> : <></>}
                                        <form name="sign_up_form" onSubmit={submitForm} id="sign_up_form">
                                            <input type="hidden" name="reCaptcha" value={reCaptchaToken} />
                                            <input type="hidden" name="type" value="Agent" />
                                            <div className="form-group" style={{ display: action === 'otp' ? "block" : "none" }}>
                                                {IEVersion() < 10 ? <label>Email address</label> : <span></span>}
                                                {
                                                    <input type="email" placeholder="Email address" className="form-control form-control-lg" id="email" name="email" />
                                                }
                                            </div>
                                            <div className="form-group slideInRight" style={{ display: action === 'verify-otp' ? "block" : "none" }}>
                                                <label>One Time Password</label>
                                                <OtpInput
                                                    value={otp}
                                                    numInputs={6}
                                                    onChange={setOtp}
                                                    separator={<span className='text-muted'>&nbsp;&nbsp;</span>}
                                                    inputStyle={"form-control form-control-lg otp"}
                                                />
                                                <div className="mt-4">
                                                    <span className="text-success">{otpMessage}</span>
                                                </div>
                                                <div className="mt-2 mb-4">
                                                    {resendOtpIn ? <small>(Resend in {resendOtpIn} seconds)</small> : <span className={`a ${resendOtpIn ? "text-muted" : 'text-secondary'}`} onClick={() => { if (!processing) submitForm('otp'); }}>Resend OTP</span>}
                                                </div>
                                                <input autoComplete='new-password' value={otp} type="hidden" id="otp" name="otp" />
                                            </div>

                                            {
                                                action == "password" ? <>
                                                    <h5 className='opacity-8 text-center mb-3 pb-1'>Create password for your account</h5>
                                                    <div className="form-group slideInRight" style={{ display: token ? "block" : "none" }}>
                                                        {IEVersion() < 10 ? <label>Enter Password</label> : <span></span>}
                                                        {
                                                            <input autoComplete='new-password' type="password" placeholder="Enter Password" className="form-control form-control-lg" id="password" name="password" />
                                                        }
                                                    </div>
                                                    <div className="form-group slideInRight" style={{ display: token ? "block" : "none" }}>
                                                        {IEVersion() < 10 ? <label>Confirm Password</label> : <span></span>}
                                                        {
                                                            <input type="password" autoComplete='new-password' placeholder="Confirm Password" className="form-control form-control-lg" id="confirm" name="confirm" />
                                                        }
                                                    </div>
                                                    <input type="hidden" name="token" value={token} />
                                                </> : <></>}

                                            <button type="submit" disabled={processing} className="btn btn-secondary btn-lg btn-block">
                                                {processing ? <span> Please Wait&hellip;</span> : buttonText()}
                                                {processing ? <span>
                                                    &nbsp;&nbsp;
                                                    <FontAwesomeIcon icon={faSpinner} className="fa-spin" />
                                                </span> : <span></span>}
                                            </button>
                                            <div className="sign-up text-center">
                                                <div className="text-center pb-3 opacity-7">
                                                    Already have an account?
                                                </div>
                                                <Link to={{
                                                    pathname: "/login",
                                                    search: queryParams.search()
                                                }} className="btn btn-success btn-lg">Back to Login</Link>
                                            </div>
                                            <PrivacyPolicy />
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Copyright />
        </div>
    );
}

export default SignUp;